<template>
	<b-card class="shadow-sm rounded-0" border-variant="white" style="margin-top:-5px;">
		<b-card-title title-tag="h3" style="min-height:33px;">{{form.title}}</b-card-title>
		<b-form class="mb-0">
			<!-- region title -->
			<b-form-row>
				<b-col cols="12" sm="12" md="10" lg="8" xl="7">
					<b-form-group
						label-cols="12"
						label-cols-sm="12"
						label-cols-md="3"
						label-cols-lg="4"
						label-cols-xl="3"
						label-align="left"
						label-align-md="right"
						label="Title:"
						label-for="title"
					>
						<b-form-input
							id="title"
							type="text"
							name="title"
							v-model.trim="form.title"
							v-validate="{
                      required: true,
                      min: 2
                    }"
							:state="validateState('title')"
						/>
					</b-form-group>
				</b-col>
			</b-form-row>

			<!-- region description -->
			<b-form-row>
				<b-col cols="12" sm="12" md="10" lg="8" xl="7">
					<b-form-group
						label-cols="12"
						label-cols-sm="12"
						label-cols-md="3"
						label-cols-lg="4"
						label-cols-xl="3"
						label-align="left"
						label-align-md="right"
						label="Description:"
						label-for="description"
					>
						<b-form-input
							id="description"
							type="text"
							name="description"
							v-model.trim="form.description"
						/>
					</b-form-group>
				</b-col>
			</b-form-row>

			<!-- action buttons -->
			<b-form-row class="mt-3">
				<b-col cols="12" sm="12" md="6" offset-md="4" lg="4" offset-lg="4" xl="3" offset-xl="4">
					<b-form-group>
						<b-button
							type="submit"
							@click.prevent="doCreateRegion"
							:disabled="$wait.is('creating region')"
							variant="success"
							block
						>
							<v-wait for="creating region">
								<template slot="waiting">
									<b-spinner small variant="light" label="Spinning" role="status"></b-spinner>&nbsp;Creating...
								</template>
								<font-awesome-icon icon="save" />&nbsp;Create Region
							</v-wait>
						</b-button>
					</b-form-group>
				</b-col>
			</b-form-row>
		</b-form>
	</b-card>
</template>

<script>
	export default {
		name: "RegionCreateForm_component",

		// components
		components: {},

		// props
		props: {},

		data() {
			return {
				form: {
					title: null,
					description: null,
					enabled: true
				}
			};
		},

		computed: {},

		methods: {
			// pass form data to parent
			doCreateRegion() {
				this.$emit("storeNewregion", this.form);
			}
		}
	};
</script>


<style scoped>
</style>
